import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/reservations.constants';
import { getAll, getForm, getOne, save, softDelete } from 'services/reservations.services';

export function* reservationsDelete(action: AnyAction): Generator {
  try {
    const { id } = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.RESERVATIONS_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.RESERVATIONS_ON_DELETE_FAILED, error });
  }
}

export function* reservationsGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({
      type: constants.RESERVATIONS_ON_GET_ALL_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.RESERVATIONS_ON_GET_ALL_FAILED, error });
  }
}

export function* reservationsGetForm(): Generator {
  try {
    const { data }: any = yield call(getForm);
    yield put({ type: constants.RESERVATIONS_ON_GET_FORM_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.RESERVATIONS_ON_GET_FORM_FAILED, error });
  }
}

export function* reservationsGetOne(action: AnyAction): Generator {
  try {
    const { id } = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.RESERVATIONS_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.RESERVATIONS_ON_GET_ONE_FAILED, error });
  }
}

export function* reservationsSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.RESERVATIONS_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.RESERVATIONS_ON_SAVE_FAILED, error });
  }
}

export function* watchReservations(): Generator {
  yield all([
    takeLatest(constants.RESERVATIONS_ON_DELETE_REQUESTED, reservationsDelete),
    takeLatest(constants.RESERVATIONS_ON_GET_ALL_REQUESTED, reservationsGetAll),
    takeLatest(constants.RESERVATIONS_ON_GET_FORM_REQUESTED, reservationsGetForm),
    takeLatest(constants.RESERVATIONS_ON_GET_ONE_REQUESTED, reservationsGetOne),
    takeLatest(constants.RESERVATIONS_ON_SAVE_REQUESTED, reservationsSave),
  ]);
}
